// ShiplistSort.tsx
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@ais-ui/ui-core';

import { SortButton } from '../../../components/SortButton';
import { ShiplistSortConfig } from './types';

interface ShiplistSortProps {
  sortConfig: ShiplistSortConfig;
  setSortConfig: React.Dispatch<React.SetStateAction<ShiplistSortConfig>>;
}

export const ShiplistSort = ({
  sortConfig,
  setSortConfig,
}: ShiplistSortProps) => {
  const toggleDirection = () => {
    setSortConfig((prev) => ({
      ...prev,
      direction: prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <SortButton
          direction={sortConfig.direction}
          label="Name"
          hideLabel={true}
          asChild={true}
          onClick={toggleDirection}
        />
      </TooltipTrigger>
      <TooltipContent>
        Sort by name ({sortConfig.direction === 'asc' ? 'A-Z' : 'Z-A'})
      </TooltipContent>
    </Tooltip>
  );
};
